module.exports = __webpack_public_path__ + "static/img/5.21e864d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/quartos/suite2/5.jpg
// module id = uYkk
// module chunks = 1